import type { RouteObject } from 'react-router';
import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

export const guideRoutes: RouteObject[] = [
  {
    path: 'guide',
    lazy: page('GuidePage'),
    handle: { title: '사용 안내', yearIndependent: true, feature: 'GUIDE' } satisfies RouteHandle,
  },
];
